import { defineVuepalAdapter } from 'vuepal/adapter'

const prefixLinks = <T>(obj: T): T => {
  const runtimeConfig = useRuntimeConfig()
  const backendUrl = runtimeConfig.public.drupalBackendUrl
  if (Array.isArray(obj)) {
    return obj.map(prefixLinks) as T
  } else if (obj && typeof obj === 'object') {
    const newObj: Record<string, unknown> = {}
    for (const key in obj) {
      const value = (obj as Record<string, unknown>)[key]
      if (
        (key === 'url' && typeof value === 'string') ||
        (key === 'imageUrl' && typeof value === 'string') ||
        (key === 'path' && typeof value === 'string')
      ) {
        newObj[key] = backendUrl + '/' + value.replace(/^\/+/, '')
      } else {
        newObj[key] = prefixLinks(value)
      }
    }
    return newObj as T
  }
  return obj
}

export default defineVuepalAdapter(() => {
  return {
    getAdminMenu() {
      return useGraphqlQuery('adminToolbar').then((v) => {
        return prefixLinks(v.data)
      })
    },
    getLocalTasks(path: string) {
      return useGraphqlQuery(
        'localTasks',
        { path },
        {
          graphqlCaching: {
            client: true,
          },
        },
      ).then((v) => {
        if (v.data.route && 'localTasks' in v.data.route) {
          return prefixLinks(v.data.route.localTasks)
        }
        return []
      })
    },
    getCurrentLanguage() {
      return computed(() => 'de')
    },
  }
})
